<template>
    <div class="content-admin-versioning">
        <AdminTools></AdminTools>
        <h1 class="">{{ $t("versioning.title") }}</h1>
        <Versioning v-if="canEdit" ref="cmpVersion"></Versioning>
        <div class="content-button">
            <button class="btn" @click="addVersionning">{{ $t("versioning.add") }}</button>
        </div>
        <div><router-link to="/admin-tools">Retour à l'administration</router-link></div>
        <div class="table-responsive content-vertionings table-size">
            <!-- <b-table striped hover bordered outlined :items="getVersionings" :fields="fieldsVersion" -->
            <!-- @row-clicked="displayVersioning"> -->
            <!-- </b-table> -->
            <table class="table table-hover  table-outlined">
                <thead>
                    <th>{{ $t("versioning.version") }}</th>
                    <th>{{ $t("versioning.name") }}</th>
                    <th>{{ $t("versioning.date") }}</th>
                    <th>{{ $t("versioning.description") }}</th>
                    <th>{{ $t("versioning.createBy") }}</th>
                    <!-- <th class="d-none d-md-block">Date</th> -->
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="(versioning, key) in getVersionings" :key="key">
                        <td class="table-title">{{ versioning.version }}</td>
                        <td class="table-title">{{ versioning.name ? versioning.name.toUpperCase() : "" }}</td>
                        <td>{{ versioning.versioningDate }}</td>
                        <td>{{ versioning.description }}</td>

                        <td>
                            {{
                                getValueObject(versioning.createdUser, "firstname", "") + " " + getValueObject(versioning.createdUser, "lastname", "")
                            }}
                        </td>

                        <!-- <td  class="d-none d-md-block">4545454</td> -->
                        <td class="content-action">
                            <button class="btn" @click="displayVersioning(versioning);">{{ $t("versioning.edit") }}</button>
                            <button class="btn" @click="removeVersioning(versioning);">{{ $t("versioning.remove") }}</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import Versioning from "./Versioning";
// import http from '../service'
import { mapActions, mapGetters } from "vuex";
import AdminTools from "../../adminTools/Admin";

export default {
    components: {
        Versioning,
        AdminTools
    },
    data() {
        return {
            vertionings: [],
            fieldsVersion: {
                id: {
                    label: this.$t("versioning.id")
                },
                name: {
                    label: this.$t("versioning.name")
                },
                version: {
                    label: this.$t("versioning.version")
                }
            }
        };
    },
    computed: {
        ...mapGetters("versioning", {
            getVersionings: "getVersionings",
            getVersioning: "getVersioning",
            canEdit: "canEdit"
        })
    },
    created() {
        this.findAllVersionings();
    },
    mounted() {},
    methods: {
        ...mapActions("versioning", {
            findAllVersionings: "findAllVersionings",
            findVersioningById: "findVersioningById",
            newVersioning: "newVersioning",
            setEdit: "setEdit",
            deleteVersioning: "deleteVersioning"
        }),
        removeVersioning(versioning) {
            this.$swal({
                title: "",
                text: this.$t("versioning.messageDelete"),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#41b4e8",
                confirmButtonText: "Oui",
                cancelButtonText: "Non"
            })
                .then(result => {
                    if (result === true) {
                        this.deleteVersioning(versioning);
                    }
                })
                .catch(() => {});
        },
        addVersionning() {
            this.newVersioning();

            // this.$router.push('/versionning')
        },
        displayVersioning(versioning) {
            this.findVersioningById(versioning.id);
        }
    }
};
</script>
<style lang="scss">
.content-button {
    padding: 5px;
    text-align: right;
}

.content-vertionings {
    width: 100%;
}

.content-admin-versioning {
    width: 100%;
    height: 100%;
}

.table-size {
    height: 100%;
    max-height: 620px;
    overflow: auto;
}

.content-action {
    text-align: center;
}

.table-title {
    font-family: "Oswald", Sans-Serif;
    margin: 2px;
    padding: 0px;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// VersioningList.vue?92497e32